(function () {
  const btn = document.createElement('a');
  btn.href = '#waitlist';
  btn.className = 'aw-sticky-btn';
  btn.setAttribute('aria-label', 'Join the mailing list');
  btn.innerHTML = `
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
    </svg>
    Join the waitlist
  `;
  document.body.appendChild(btn);

  const style = document.createElement('style');
  style.textContent = `
    .aw-sticky-btn {
      position: fixed;
      bottom: 28px;
      right: 28px;
      z-index: 9999;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #0f0f1a;
      color: #fff;
      text-decoration: none;
      font-family: 'DM Sans', sans-serif;
      font-size: 14px;
      font-weight: 700;
      padding: 13px 22px;
      border-radius: 999px;
      box-shadow: 0 4px 20px rgba(0,0,0,.25);
      transition: background .15s, transform .15s, box-shadow .15s;
      white-space: nowrap;
    }
    .aw-sticky-btn:hover {
      background: #E8603A;
      color: #fff;
      transform: translateY(-2px);
      box-shadow: 0 8px 28px rgba(232,96,58,.35);
    }
    .aw-sticky-btn svg { flex-shrink: 0; }
    @media (max-width: 480px) {
      .aw-sticky-btn {
        bottom: 16px;
        right: 16px;
        font-size: 13px;
        padding: 11px 18px;
      }
    }
  `;
  document.head.appendChild(style);
})();